export default {
  theme: () => import(/* webpackChunkName: "stanleybet-themeWrap" */'./ThemeImporter'),
};
